export default __webpack_public_path__ + "static/media/mv-dtc-iphone-1.2aec1c40.png";